import React from "react";
import { Play, MessageCircle, Youtube, Globe } from "lucide-react";
import { LINKS } from "../../lib/site";

const links = [
  { label: "Privacy Policy", href: "#" },
  { label: "Refund Policy", href: "#" },
  { label: "Terms and Conditions", href: "#" },
  { label: "Contact", href: LINKS.whatsapp },
];

export default function Footer() {
  return (
    <footer className="bg-brand-black text-brand-cream border-t-2 border-brand-cream/10 px-5 sm:px-8 md:px-12 py-14 sm:py-16">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid md:grid-cols-[1.2fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-9 w-9 rounded-lg bg-brand-red flex items-center justify-center border-2 border-brand-cream/20"><Play size={16} className="text-white fill-white ml-0.5" /></span>
              <span className="font-display text-xl">Ratish Jha</span>
            </div>
            <p className="font-display text-2xl sm:text-3xl mt-5 leading-tight">YouTube Lead Generation Mastery</p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-brand-cream/50">Links</p>
            <ul className="mt-4 space-y-2.5">
              {links.map((l) => (
                <li key={l.label}><a href={l.href} className="text-sm text-brand-cream/80 hover:text-brand-yellow transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-brand-cream/50">Connect</p>
            <ul className="mt-4 space-y-2.5">
              <li><a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-brand-cream/80 hover:text-brand-green transition-colors"><MessageCircle size={15} /> WhatsApp</a></li>
              <li><a href={LINKS.youtube} className="flex items-center gap-2 text-sm text-brand-cream/80 hover:text-brand-red transition-colors"><Youtube size={15} /> YouTube</a></li>
              <li><a href={LINKS.website} className="flex items-center gap-2 text-sm text-brand-cream/80 hover:text-brand-blue transition-colors"><Globe size={15} /> Website</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t-2 border-brand-cream/10">
          <p className="text-xs text-brand-cream/50 leading-relaxed max-w-3xl">
            Results vary based on niche, expertise, offer, communication, consistency, and implementation. No income or ranking outcome is guaranteed.
          </p>
          <p className="text-xs text-brand-cream/40 mt-4">© {new Date().getFullYear()} Ratish Jha. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
